module.exports = __webpack_public_path__ + "blacklotusflower.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blacklotusflower.png
// module id = 858
// module chunks = 0